import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe as NgxTranslatePipe, TranslateService } from '@ngx-translate/core';
import { DeepKeyLiteral, DeepMergeTypes } from 'core/type-utils';
import { default as enJson, default as hrJson } from 'projects/designer/src/assets/i18n/en.json';

type EnKeys = typeof enJson;
type HrKeys = typeof hrJson

type TranslationKeys = DeepMergeTypes<EnKeys, HrKeys>;
export type DsgDeepTranslationKey = DeepKeyLiteral<TranslationKeys, ''> | '';

@Pipe({ name: 'translate', pure: false, standalone: true })
export class DsgTranslatePipe implements PipeTransform {

  readonly ngxPipe = new NgxTranslatePipe(this._translateService, this._changeDetectorRef);

  constructor(
    private readonly _translateService: TranslateService,
    private readonly _changeDetectorRef: ChangeDetectorRef
  ) { }

  transform(value: DsgDeepTranslationKey, ...args: unknown[]): string {
    return this.ngxPipe.transform(value, ...args);
  }

}
